import CardCreator from '../components/CardCreator';
import { withSession } from '../components/EmbedSession';

function EmbedCreator() {
  return <CardCreator />;
}

export default withSession(EmbedCreator);
